export default __webpack_public_path__ + "static/media/student_mission_3.19fcf8ab.png";